'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = require('rp-mq-breakpoints');

var _commonMenu = require('./commonMenu');

var _commonMenu2 = _interopRequireDefault(_commonMenu);

var _secondaryMenuItemBuilder = require('./secondaryMenuItemBuilder');

var _secondaryMenuItemBuilder2 = _interopRequireDefault(_secondaryMenuItemBuilder);

var _secondaryMenuItemActiveNarrow = require('./secondaryMenuItemActiveNarrow');

var _secondaryMenuItemActiveNarrow2 = _interopRequireDefault(_secondaryMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu
 * @augments CommonMenu
 * @constructor
 */
function SecondaryMenu() {
    _commonMenu2.default.prototype.constructor.apply(this, arguments);

    this.activeItemNarrow = new _secondaryMenuItemActiveNarrow2.default('#secondaryCurrent');

    this.itemBuilder = new _secondaryMenuItemBuilder2.default();
    this.itemSelector = '.rn-secondaryNav__list__item';

    this.$outerObj = (0, _jquery2.default)('.rn-secondaryNav');
    this.$navPointer = (0, _jquery2.default)('.rn-secondaryNav__pointer');
    this.$select = (0, _jquery2.default)('.rn-secondaryNav__select');
    this.$close = (0, _jquery2.default)('.rn-secondaryNav__close');
    this.$parent = (0, _jquery2.default)('body');
    this.$overlay = (0, _jquery2.default)('<div class="ui-overlay" />');
    this.$overlayFrom = (0, _jquery2.default)('.rn-menuBar');

    this.secondaryPointerPreRender = 'rn-secondaryNav__pointer_preRender';
    this.secondaryActiveClass = 'rn-secondaryNav_active';

    this.openedSecondary = false;
    this.firstClickSecondary = false;

    this.init();
} /**
   * @module navigation/secondaryMenu
   * @requires module: navigation/commonMenu
   * @requires module: navigation/secondaryMenuItemBuilder
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

SecondaryMenu.prototype = (0, _create2.default)(_commonMenu2.default.prototype);

/**
 * Bind events
 * @private
 */
SecondaryMenu.prototype._bindEvents = function () {
    var self = this;
    this.getNavigationContainer().on('changePointerPosition.secondaryNav', this._changePointerPositionHandler());
    this.$select.on('click', function (event) {
        event.preventDefault();
        if (!self.openedSecondary) {
            self.firstClickSecondary = true;
            self._openNarrow();
        } else {
            self._closeNarrow();
        }
    });
    this.$close.on('click', function (event) {
        event.preventDefault();
        self._closeNarrow();
    });
    (0, _jquery2.default)(window).on('rpBreakpointsSwitch', this._changeBreakpointsHandler()).on('scroll', this._onWindowScrollHandler());
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._onWindowScrollHandler = function () {
    var self = this;
    return function () {
        if (self.openedSecondary) {
            self._positionOverlay();
        }
    };
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._changeBreakpointsHandler = function () {
    var self = this;

    return function (event) {
        if (self.openedSecondary) {
            self._positionOverlay();
        }

        if (self.openedSecondary && ![_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW].includes(event.detail.breakpoint.code)) {
            self._closeNarrow();
        }
    };
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._openNarrow = function () {
    if (this.openedSecondary) {
        return;
    }
    this.$outerObj.addClass(this.secondaryActiveClass);
    this.$parent.append(this.$overlay);
    this.openedSecondary = true;
    this._positionOverlay();

    (0, _jquery2.default)(document).on(['click', 'touchstart'].map(function (event) {
        return event + '.rp.navigation.secondary';
    }).join(' '), this._onClickNavigationSecondaryHandler());
};

/**
 * @private
 */
SecondaryMenu.prototype._positionOverlay = function () {
    this.$overlay.position({
        my: 'left top',
        at: 'left bottom',
        of: this.$overlayFrom.eq(0)
    });
};

SecondaryMenu.prototype._onClickNavigationSecondaryHandler = function () {
    var self = this;

    return function (event) {
        if (self.firstClickSecondary) {
            self.firstClickSecondary = false;
        } else if (!self.$outerObj[0].contains(event.target)) {
            self._closeNarrow();
        }
    };
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._closeNarrow = function () {
    this.$outerObj.removeClass(this.secondaryActiveClass);
    this.$overlay.remove();
    this.openedSecondary = false;

    (0, _jquery2.default)(document).unbind('.rp.navigation.secondary');
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._changePointerPositionHandler = function () {
    var self = this;

    return function (event, position) {
        self.$navPointer.offset({ left: position - self.$navPointer.outerWidth() / 2 }).removeClass(self.secondaryPointerPreRender);
    };
};

exports.default = SecondaryMenu;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/secondaryMenu.js
// module id = 1466
// module chunks = 1